export class Comissao {
  id: number;
  descricao: string;
  percKitPronto: number;
  itens: ComissaoItem[];
}

export class ComissaoItem {
  id: number;
  idComissao: number;
  inicio: number;
  fim: number;
  valor: number;
  situacao: number;

  // somente exibição
  valorCalculado: number;
}
